import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {

  const getInitialTrainingProviders = () => {
    let mapOfTpIdName = {};
    try {
      const training_providers = JSON.parse(sessionStorage.getItem("training_providers"));
      if (training_providers && Array.isArray(training_providers)) {
        training_providers.forEach(element => {
          mapOfTpIdName[element.tp_id] = element.provider_name;
        });
      } else {
        mapOfTpIdName["1001"] = "Lambton College";
      }
    } catch (e) {
      mapOfTpIdName["1001"] = "Lambton College";
    }
    return mapOfTpIdName;
  };

  const [screenDetails, setScreenDetails] = useState({ fieldSize: "md", stackOrientation: "row", cardOrientation: "horizontal" });
  
  const [userData, setUserData] = useState({ user_id: "", firstName: "", lastName: "", dob: "" });
  const [roleDetail, setRoleDetail] = useState({ roleId: 0, roleName: "" });
  const [homeDetail, setHomeDetail] = useState({ homeId: 0, homeName: "" });

  const [policyDetails, setPolicyDetails] = useState({});
  const [trainingProviders, setTrainingProviders] = useState(() => getInitialTrainingProviders());
  const [policyDataList, setPolicyDataList] = useState([]);
  const [courseDataList, setCourseDataList] = useState([]);
  const [pendingPolicyCount, setPendingPolicyCount] = useState(0);

  const updateUserDetails = (data) => setUserData((prev) => ({ ...prev, ...data }));
  const updateGlobalRoleDetails = (data) => setRoleDetail((prev) => ({ ...prev, ...data }));
  const updateGlobalHomeDetails = (data) => setHomeDetail((prev) => ({ ...prev, ...data }));
  const updateCurrentPolicy = (data) => setPolicyDetails((prev) => ({ ...prev, ...data }));
  const updateCurrentPolicyDataList = (data) => setPolicyDataList(data);
  const updateCourseDataList = (data) => setCourseDataList(data);
  const updatePendingPolicyCount = (data) => setPendingPolicyCount(data);

  const updateTrainingProviders = () => {
    setTrainingProviders(getInitialTrainingProviders());
  };

  const updateScreenDetails = (isSmScreen) => {
    setScreenDetails(prev => {
      if(isSmScreen)
        return {...prev, fieldSize:"sm", stackOrientation:"column", cardOrientation: "vertical"}
      else
        return {...prev, fieldSize:"md", stackOrientation:"row", cardOrientation: "horizontal"}
    } )
  }

  


  return (
    <UserContext.Provider value={{
      userData, roleDetail, homeDetail, policyDetails, policyDataList, 
      courseDataList, pendingPolicyCount, trainingProviders, screenDetails,
      updateUserDetails, updateGlobalRoleDetails, updateGlobalHomeDetails, updateCurrentPolicy,
      updateCurrentPolicyDataList, updateCourseDataList, updatePendingPolicyCount, updateTrainingProviders, updateScreenDetails
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
